import { render, staticRenderFns } from "./ProblemDistribution.vue?vue&type=template&id=416c412b&scoped=true"
import script from "./ProblemDistribution.vue?vue&type=script&lang=js"
export * from "./ProblemDistribution.vue?vue&type=script&lang=js"
import style0 from "./ProblemDistribution.vue?vue&type=style&index=0&id=416c412b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c412b",
  null
  
)

export default component.exports